import Container from './container'

export default Container



// WEBPACK FOOTER //
// ./src/iss-credentials-update/index.js